module.exports = __webpack_public_path__ + "historicalDrawdownChart.4b265a1f08c55b6a5b39db1b228ec536.png";